import VerifiedVehicles from '../../../../components/verified-vehicles-tag/verified-vehicles-tag.desktop';
import verifiedVehicles from './verified-vehicles-tag';

export default verifiedVehicles(VerifiedVehicles);
